/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const MyEmailsResponse = zod.object({
  emails: zod.array(
    zod.object({
      email: zod.email().describe('The email address'),
      primary: zod
        .boolean()
        .describe('True for the primary address (login\/JWT claim and profile email)'),
      verified: zod.boolean().describe('True once the address has passed OTP verification'),
    }),
  ),
});

export type MyEmailsResponse = zod.input<typeof MyEmailsResponse>;
export type MyEmailsResponseOutput = zod.output<typeof MyEmailsResponse>;
